// Note: the contract between LinkedColumn / LinkedRow (which set the attributes) and LinkedColumns
// (which finds the rows by them to draw the connectors and the dim style). Nothing else reads them.
export const LINKED_ATTRIBUTES = {
  column: 'data-linked-column',
  list: 'data-linked-list',
  row: 'data-linked-row',
  selected: 'data-selected',
} as const

export const getColumnAttributes = (dndType: string) => ({
  [LINKED_ATTRIBUTES.column]: dndType,
})

export const LIST_ATTRIBUTES = { [LINKED_ATTRIBUTES.list]: true }

export const getRowAttributes = (dndId: string, selected: boolean) => ({
  [LINKED_ATTRIBUTES.row]: dndId,
  [LINKED_ATTRIBUTES.selected]: selected || undefined,
})

export const getColumnSelector = (dndType: string) => `[${LINKED_ATTRIBUTES.column}="${dndType}"]`

export const LIST_SELECTOR = `[${LINKED_ATTRIBUTES.list}]`
export const ROW_SELECTOR = `[${LINKED_ATTRIBUTES.row}]`
export const SELECTED_SELECTOR = `[${LINKED_ATTRIBUTES.selected}]`
export const SELECTED_ROW_SELECTOR = `${ROW_SELECTOR}${SELECTED_SELECTOR}`
